/**
 * @file   src\mobile\components\WantAdListing\ClosedWantAds.js
 * @brief  This file is responsible for showing closed want ads listing
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import WantAdFeatures from "./v2/WantAdFeatures";

const ClosedWantAds = () => {
  return <WantAdFeatures />;
};

export default ClosedWantAds;
